import type { AttachmentItem } from '@/types/models'
import request from './request'

type UploadResponse = {
  id: string
  url: string
}

type FileUploader = (
  file: File,
  progress: (value: number) => void
) => Promise<UploadResponse>

// What the attachments API takes: the application allows 10 MB on an ordinary
// project, and the proxy in front of it caps the request body. A bigger file is
// refused by the proxy before the application sees it, and the refusal carries
// no CORS headers, so the browser reports it as a lost connection instead of a
// size (OCT-5377). Asking for the size here keeps that out of the way.
export const MAX_UPLOAD_SIZE = 10 * 1024 * 1024

export const isTooLargeToUpload = (file: File) => file.size > MAX_UPLOAD_SIZE

export const getFileUploader = (
  projectId: string | null,
  onSuccess?: (item: AttachmentItem[]) => void
): FileUploader | null => {
  if (!projectId) {
    return null
  }

  return (file, progress) => {
    const formData = new FormData()
    formData.append('file', file)

    return request
      .multipart<AttachmentItem>(
        `/projects/${projectId}/attachments`,
        formData,
        {},
        {
          onUploadProgress: (progressEvent) => {
            // @ts-expect-error
            progress((progressEvent.loaded / progressEvent.total) * 100)
          },
        }
      )
      .then((response) => {
        if (onSuccess) {
          onSuccess([response])
        }

        return {
          url: response.downloadUrl,
          id: response.id,
        }
      })
  }
}
